import { useAppSelector } from 'app/store';
import { getRelease } from 'app/store/Releases/selectors';
import React from 'react';
import { SoundCloudVersionDetailsForm } from 'app/components/Releases/SoundCloudVersionDetailsForm';
import { LabelVersionDetailsForm } from 'app/components/Releases/LabelVersionDetailsForm';
import { Navigate } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';
import { TuneCoreVersionDetailsForm } from 'app/components/Releases/TuneCoreVersionDetailsForm';
import { LabelV2VersionDetailsForm } from 'app/components/Releases/LabelV2VersionDetails';

export const ReleaseDetailsFormRedirect = () => {
  const release = useAppSelector(getRelease);
  const guid = release?.guid;

  if (release?.type === 'SoundCloud') {
    return <SoundCloudVersionDetailsForm />;
  }

  if (release?.type === 'TuneCore') {
    return <TuneCoreVersionDetailsForm />;
  }

  if (release?.type === 'Label') {
    return <LabelVersionDetailsForm />;
  }

  if (release?.type === 'LabelV2') {
    return <LabelV2VersionDetailsForm />;
  }

  return (
    <Navigate
      to={
        guid ? routes.release.path.replace(':guid', guid) : routes.releases.path
      }
    />
  );
};
